import useTranslation from "next-translate/useTranslation";
import React from "react";
import formatUrl from "utils/FormatUrl";
import style from "./style.module.css";

function Simulez(props) {
  const url = `${props.button_link}`;
  const { lang } = useTranslation("");
  return (
    <div className={style.container}>
      <p className={style.question}>{props.title}</p>
      <button className={style.button}>
        <a
          rel={
            props.button_link?.includes("list") ||
            props.button_link?.includes("map") ||
            props.button_link?.includes("?") ||
            props.button_link?.includes("conditions") ||
            props.button_link?.includes("contact")
              ? "noindex, nofollow, noreferrer"
              : "dofollow"
          }
          href={formatUrl(props.button_link, lang)}
          target="_blank"
        >
          {props.buttonText}
        </a>
      </button>
    </div>
  );
}

export default Simulez;
